import { render, staticRenderFns } from "./ViewAllDetailsOrderItem.vue?vue&type=template&id=5ebe241a&scoped=true"
import script from "./ViewAllDetailsOrderItem.vue?vue&type=script&lang=js"
export * from "./ViewAllDetailsOrderItem.vue?vue&type=script&lang=js"
import style0 from "./ViewAllDetailsOrderItem.vue?vue&type=style&index=0&id=5ebe241a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe241a",
  null
  
)

export default component.exports